exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* App z-index tracking */\n.gybu2-dLegU_paamzOHIj {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 24px 32px;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 450;\n  background-color: #f2faff;\n  color: #111111; }\n  .gybu2-dLegU_paamzOHIj ._2PyldTDdq_R4sVULTr5_Du {\n    display: grid;\n    grid-template-columns: min-content 1fr;\n    align-items: center;\n    gap: 8px; }\n    .gybu2-dLegU_paamzOHIj ._2PyldTDdq_R4sVULTr5_Du ._1ckczRrOQe3cM1SOkQEQ10 {\n      display: grid;\n      grid-template-columns: 1fr min-content;\n      align-items: center;\n      gap: 32px; }\n  .gybu2-dLegU_paamzOHIj ._3YjUVe29WAK28ObKM6tLjv {\n    margin: 0;\n    text-wrap: pretty; }\n  .gybu2-dLegU_paamzOHIj .gTEwQvVO8dYZYmW0noWqk {\n    display: inline-block;\n    margin-right: 2px;\n    font-size: 18px; }\n", ""]);

// exports
exports.locals = {
	"announcement": "gybu2-dLegU_paamzOHIj",
	"announcementContent": "_2PyldTDdq_R4sVULTr5_Du",
	"copyWrap": "_1ckczRrOQe3cM1SOkQEQ10",
	"announcementCopy": "_3YjUVe29WAK28ObKM6tLjv",
	"emoji": "gTEwQvVO8dYZYmW0noWqk"
};